import { EditViewEnum } from '../models/edit-view.enum';
import { ToolEnum } from 'src/app/engine/models/tool.enum';

export class EditStateModel {
    view: EditViewEnum;
    showColumns: boolean;
    showLeftColumn: boolean;
    showRightColumn: boolean;
    showHeader: boolean;
    showFooter: boolean;
    record: boolean;
}
